import { useCallback } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh } from '@fortawesome/pro-regular-svg-icons'
import { cn } from '@sweetspot/scramble-ds/utils'

interface RefreshButtonProps {
  isLoading: boolean
  handleRefresh: () => void
  disabled: boolean
}

const RefreshButton = ({ isLoading, handleRefresh, disabled }: RefreshButtonProps) => {
  const onRefresh = useCallback(() => {
    if (disabled) return
    handleRefresh()
  }, [disabled, handleRefresh])

  return (
    <div className="flex">
      <FontAwesomeIcon
        icon={faRefresh}
        size="1x"
        className={cn(
          'flex cursor-pointer items-center justify-center px-1 lg:px-3',
          disabled && 'cursor-not-allowed opacity-40',
          isLoading && 'animate-spin-and-pulse'
        )}
        onClick={onRefresh}
      />
    </div>
  )
}

export default RefreshButton
